import { inject, Injectable } from '@angular/core';
import { LogService } from 'shared/core/data-access/log';
import { StorageService } from 'shared/core/data-access/storage';
import { isEnum } from 'shared/framework/util/typescript';
import { ThemeEnum } from '../../enums/theme/theme.enum';
import { DEFAULT_THEME } from '../../providers/default-theme/default-theme.token';

@Injectable({
    providedIn: 'root',
})
export class ThemeService {
    #storageService = inject(StorageService);
    #logService = inject(LogService);
    #defaultTheme = inject(DEFAULT_THEME, { optional: true });
    #themeStorage = this.#storageService.createLocalStorage(
        'theme',
        this.#defaultTheme,
    );

    init = () => {
        this.#logService.debug(`[Theme] Using ${this.getTheme()}`);
    };

    get defaultTheme(): ThemeEnum {
        if (isEnum(this.#defaultTheme, ThemeEnum)) {
            return this.#defaultTheme;
        } else {
            return ThemeEnum.LIGHT;
        }
    }

    getTheme = (): ThemeEnum => {
        const theme = this.#themeStorage.get();

        if (isEnum(theme, ThemeEnum)) {
            return theme;
        } else {
            this.setTheme(this.defaultTheme);

            return this.defaultTheme;
        }
    };

    setTheme = (theme: ThemeEnum) => {
        this.#themeStorage.set(theme);
    };
}
